import React from "react";
import {Badge, Spinner} from "react-bootstrap";
import useBankHolidaysToggle from "../hooks/useBankHolidays";
import {appFirestore} from "../../index";
import {getDocs, query, collection, where} from "firebase/firestore";
import {useAppSelector} from "../hooks";
import {stringAsDepartment} from "../types/RRDepartmentType";

interface Props {
    departmentKey: string; // e.g. "logistics" or activeDepartment
    dateStr: string;
    className?: string;
}

export default function BankHolidayToggle({departmentKey, dateStr, className}: Props) {
    const currentEmployee = useAppSelector((state: any) => state.app.currentEmployee);
    const toggle = useBankHolidaysToggle();
    const [working, setWorking] = React.useState<string | null>(null);
    const [isHoliday, setIsHoliday] = React.useState<boolean>(false);

    const refresh = React.useCallback(async () => {
        const dept = stringAsDepartment(departmentKey);
        const q = query(collection(appFirestore, "bankHolidays"), where("date", "==", dateStr), where("department", "==", dept));
        const snap = await getDocs(q);
        setIsHoliday(snap.docs.length > 0);
    }, [dateStr, departmentKey]);

    React.useEffect(() => {
        refresh();
        // also refresh whenever dateStr or departmentKey changes
    }, [refresh]);

    return (
        <span className={(className ? className : "") + " cursor-pointer"}
              onClick={async () => {
                  try {
                      await toggle(departmentKey, dateStr, currentEmployee, setWorking);
                      await refresh();
                  } catch (e: any) {
                      // let callers handle errors via toast/alert; simple fallback
                      if (e.message === "NO_PERMISSION") alert("Само администратор може да извършва тази операция!");
                      else if (e.message === "INVALID_DATE") alert("Невалидна дата");
                      else alert(e.message);
                  }
              }}>
            {working === dateStr ? <Spinner size={"sm"}/> : <Badge bg={isHoliday ? "primary" : "secondary"}>H</Badge>}
        </span>
    )
}
